import React from 'react';

export default function Layout({ children, pageTitle, pageSubtitle, navExtra }) {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <header className="site-header">
        <img src="https://www.a-ldi.com/images/Logo.274.90.gif" alt="American Laundry Distributors, Inc." />
      </header>

      {/* NAV — sign out only, no site links */}
      {navExtra && (
        <nav className="site-nav">
          <ul style={{ justifyContent: 'flex-end' }}>
            {navExtra}
          </ul>
        </nav>
      )}

      {pageTitle && (
        <div className="page-title-bar">
          <h1>{pageTitle}</h1>
          {pageSubtitle && <p>{pageSubtitle}</p>}
        </div>
      )}

      <main className="main-content" style={{ flex: 1 }}>{children}</main>

      <footer className="site-footer">
        <div className="footer-inner">
          <div className="footer-col">
            <h4>American Laundry Distributors, Inc.</h4>
            <p>12716 O'Connor Rd.<br />San Antonio, TX 78233</p>
          </div>
          <div className="footer-col">
            <h4>Contact</h4>
            <p>
              <a href="mailto:info@a-ldi.com">info@a-ldi.com</a><br />
              <a href="tel:2106615995">210.661.5995</a>
            </p>
          </div>
          <div className="footer-col">
            <h4>Integrity. Performance. Solutions.</h4>
            <p>Serving Texas and beyond since 2005.</p>
          </div>
        </div>
        <div className="footer-bottom">&copy; American Laundry Distributors, Inc. &nbsp;|&nbsp; All Rights Reserved</div>
      </footer>
    </div>
  );
}
